import Aegis, { WebConfig } from 'aegis-web-sdk';

let aegis: Aegis | null = null;

export const initAegis = (id: string, options?: WebConfig) => {
  aegis = new Aegis({
    id, // 硅谷
    reportApiSpesed: true, // 接口测速
    reportAssetSpeed: true, // 静态资源测速
    spa: true, // spa 应用页面跳转的时候开启 pv 计算
    hostUrl: 'https://rumt-us.com',
    beforeReport: (err: any) => {
      // 忽略 beacon 灯塔上报请求
      if (err?.msg?.match(/hok-web-http\.tlog\.iegcom\.com/gi)) {
        return false;
      }
      // 忽略 localhost 灯塔上报请求
      if (err?.msg?.match(/localhost/gi)) {
        return false;
      }
      // 忽略 localhost 灯塔上报请求
      if (err?.msg?.from(/localhost/gi)) {
        return false;
      }
      // eslint-disable-next-line sonarjs/prefer-single-boolean-return
      if (err?.msg?.match(/htrace\.wetvinfo\.com/gi)) {
        return false;
      }
      return true;
    },
    ...options,
  });
};

/**
 * 自定义上报采集测速事件
 * @param id 上报的事件id
 * @param time 上报测速事件的时间
 */
export const aegisReportTime = (id: string, time: number) => {
  if (time > 0) {
    aegis?.reportTime({
      name: id,
      duration: time,
    });
  }
};

/**
 * 以某张图片的加载完成时间作为首屏时间点上报
 * @param id 上报的事件id
 * @param name 上报的图片名称
 */
export const aegisReportFirstScreenImage = (id: string, name: string) => {
  console.log('aegisReportFirstScreenImage');
  try {
    const resourcePerformance = performance.getEntriesByType('resource');
    for (const item of resourcePerformance) {
      if (item.name.includes(`/${name}.`) && item?.toJSON()?.responseEnd) {
        console.log(`${id} 上报`, item.toJSON().responseEnd);
        aegis?.reportTime({
          name: id,
          duration: item.toJSON().responseEnd,
        });
      }
    }
    setTimeout(() => {
      if ((window as any)?.firstPaint > 0) {
        console.log('firstPaint 上报', (window as any)?.firstPaint);
        aegis?.reportTime({
          name: 'first-paint',
          // 上报firstPaint时间作为参考，需要在html的head中加入以下代码
          duration: (window as any)?.firstPaint,
        });
      }
    }, 1000);
  } catch (error) {
    console.log('aegis reportTime fail', error);
  }
};
// 在html的header中进行添加
// const observer = new PerformanceObserver(function (list, obj) {
//   const entries = list.getEntries();
//   if (entries?.[0].toJSON()?.startTime) {
//     window.firstPaint = entries[0].toJSON()?.startTime;
//     observer.disconnect();
//   }
// });

// observer.observe({ type: 'paint', buffered: true });
